import React, { ReactElement, useEffect, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Hub } from 'aws-amplify';

import { Button } from '../molecules';

import { validateEmail } from '../../utils/validators';
import { forgotPassword } from '../../utils/auth-functions';
import errorStyling from '../../utils/error-styling';

type Props = {
  email?: string
};

export default function ForgotPasswordForm({ email }: Props): ReactElement {
  const [emailState, setEmailState] = useState<string | undefined>(email);
  const [error, setError] = useState<string | boolean | undefined>(undefined);
  const [emailIsValid, setEmailIsValid] = useState<boolean | undefined>(true);

  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  /* const redirectUrl = queryString.get('redirectUrl'); */
  const inApp = queryString.get('inApp');
  const history = useHistory();

  const handleResetPassword = () => {    
    if (emailState) {
      if (validateEmail({ email: emailState || '' }) === 'valid') {
        setEmailIsValid(true);
        forgotPassword(emailState);
      } else setEmailIsValid(false);
    } else setEmailIsValid(false);
  };

  Hub.listen('auth', (hub) => {
    const { payload: { data: { code }, event } } = hub;    
    if (event === 'forgotPassword_failure') {
      setError(code);
    } else {
      setError(false);
    }
  });

  useEffect(() => {
    if (error === false) {
      history.replace(inApp === 'true' ? '/reset-password?inApp=true' : '/reset-password');
    }
  }, [error]);

  return (
    <form id="email-form">
      <div className="form-group">
        <div className="input-group d-block">
          <input onChange={(e) => setEmailState(e.target.value)} type="email" name="username" className="form-control w-100" placeholder={email || 'Email'} />
        </div>
      </div>
      {!emailIsValid && <div className="input-not-valid mt-2">Email non valida!</div>}
      <div className="d-flex align-items-center flex-column">
        <Button
          role="button"
          type={'submit'}
          action={() => handleResetPassword()}
          className="btn override btn-primary mt-3 mb-2"
        >
            Resetta
        </Button>
        {typeof error === 'string'  && (<div className="input-not-valid text-center mb-4">{errorStyling(error)}</div>)}
        <Link className="link-override" to={inApp === 'true' ? '/?inApp=true' : '/'}>Oppure torna indietro</Link>
      </div>
    </form>
  );
}